import request from '@/utils/request'

// 1、现居地址--获取省市区列表数据
export function getArea(query) {
    return request({
      url: '/system/config/ssx',
      method: 'get',
      params: query
    })
  }

// 2、获取接包方个人信息
export function getAcpUserInfo() {
  return request({
    url: '/contractorinfo',
    method: 'get'
  })
}

// 3、保存接包方个人信息
export function putAcpUserInfo(data) {
  return request({
    url: '/contractorinfo',
    method: 'put',
    data: data
  })
}

// 4、用户获取工作包数量
export function getJobNum() {
  return request({
    url: '/projectPackage/myJobNumber',
    method: 'get',
  })
}



// WEBPACK FOOTER //
// ./src/api/accept/userInfo/userInfo.js